import { ToolkitListingID } from '@aloft/toolkit-shared';

import { formatReferenceViewID, parseReferenceViewID } from '../../modules/referenceView/index.ts';
import { isReferenceViewPropertyIDParsed } from '../../modules/referenceView/referenceViewID/isReferenceViewPropertyIDParsed.ts';
import { useMetadataByID } from './useMetadataByID.ts';

export type ListingIDsByPropertyID = { [index: string]: ToolkitListingID | undefined };
export const useListingIDsByPropertyID = (): ListingIDsByPropertyID => {
  const metadataByID = useMetadataByID();

  const listingIDByPropertyID: ListingIDsByPropertyID = {
    subject: metadataByID[formatReferenceViewID({ type: 'subject' })]?.listingID,
  };

  Object.entries(metadataByID).forEach(([id, metadata]) => {
    const parsed = parseReferenceViewID(id);
    if (parsed && isReferenceViewPropertyIDParsed(parsed) && parsed.type === 'comparable') {
      listingIDByPropertyID[parsed.compID] = metadata.listingID;
    }
  });

  return listingIDByPropertyID;
};
